import { render } from "./memberCardPriceModel.vue?vue&type=template&id=f35cc97e"
import script from "./memberCardPriceModel.vue?vue&type=script&lang=js"
export * from "./memberCardPriceModel.vue?vue&type=script&lang=js"

import "./memberCardPriceModel.vue?vue&type=style&index=0&id=f35cc97e&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__